import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormValidatorService } from '../shared-services/form-validator.service';
import { HistoryProvider } from '../core/browser-providers';
import { MediaService } from '../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { DialogService } from '../shared-components/modals/dialog.service';
import { TiposEnvio } from './tiposEnvio.model';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';

@Component({
  selector: 'app-tiposEnvio-add-edit',
  templateUrl: './tiposEnvio-add-edit.component.html',
  styleUrls: ['./tiposEnvio-add-edit.component.scss']
})
export class TiposEnvioAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  tiposEnvio: TiposEnvio;

  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.tiposEnvio = data.user;
      this.tiposEnvio.description = this.tiposEnvio.id ? this.tiposEnvio.description : '';
    });

    this.messageTitle = this.tiposEnvio.id  ? 'Edición de tipos de envío' : 'Alta de tipos de envío';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el tipo de envío ' + this.tiposEnvio.description + '?')
    .then( res => {
      if (res) {
        this.saveTiposEnvio(res);
      }
    });
  }

  async saveTiposEnvio(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.tiposEnvio.id) { // Update
        try {
          await await this.backendService.update(TiposEnvio.path + this.tiposEnvio.id, this.tiposEnvio);
          this.snackService.success('Tipo de envío editado');
          this.router.navigate(['/tiposEnvio']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(TiposEnvio.path, this.tiposEnvio);
          this.snackService.success('Tipo de envio creado');
          this.router.navigate(['/tiposEnvio']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio-add-edit.component.ts